import { adalApiFetch } from "authProvider";
import { endPoints, API_ROOT } from "appSettings";

export const getPermissions = () => {
  return (dispatch: any) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.authorization}/evaluate`,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      },
      dispatch
    ).then((response: any) => response.json());
  };
};
